/*
* Association amenity responsibilities form view for authenticated users
*/

import * as _ from 'lodash';
import * as React from 'react';
import { Row } from 'react-bootstrap';

import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
import * as DetailFormCommon from './common';

export const AssociationDetailsAmenityResponsibilitiesExteriorNumeric = ({
    appText,
    handleFormInputChange,
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,    
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        colLabelXs: 6,
        colInputXs: 6,
    });

    return (
        <DetailFormCommon.AssociationDetailFormSection title={sectionTitle}>
            <Row>
                <Col xs={6}>
                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.pools"
                            label={appText('pools')}
                            value={formData.details.pools}
                            {...inputProps}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.spas"
                            label={appText('spas')}
                            value={formData.details.spas}
                            {...inputProps}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.wadingPools"
                            label={appText('wading-pools')}
                            value={formData.details.wadingPools}
                            {...inputProps}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.saunas"
                            label={appText('saunas')}
                            value={formData.details.saunas}
                            {...inputProps}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.marinasDocks"
                            label={appText('marinas-docks')}
                            value={formData.details.marinasDocks}
                            {...inputProps}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.generators"
                            label={appText('generators')}
                            value={formData.details.generators}
                            {...inputProps}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.waterHeaters"
                            label={appText('water-heaters')}
                            value={formData.details.waterHeaters}
                            {...inputProps}
                        />
                    </div>
                </Col>
                <Col xs={6}>
                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.boilers"
                            label={appText('boilers')}
                            value={formData.details.boilers}
                            {...inputProps}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.hvacUnits"
                            label={appText('hvac-units')}
                            value={formData.details.hvacUnits}
                            {...inputProps}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.chillers"
                            label={appText('chillers')}
                            value={formData.details.chillers}
                            {...inputProps}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.maintenanceBuildings"
                            label={appText('maintenance-buildings')}
                            value={formData.details.maintenanceBuildings}
                            {...inputProps}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.volleyballCourts"
                            label={appText('volleyball-courts')}
                            value={formData.details.volleyballCourts}
                            {...inputProps}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.basketballCourts"
                            label={appText('basketball-courts')}
                            value={formData.details.basketballCourts}
                            {...inputProps}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoNumberInput
                            name="details.tennis"
                            label={appText('tennis')}
                            value={formData.details.tennis}
                            {...inputProps}
                        />
                    </div>
                </Col>
            </Row>
        </DetailFormCommon.AssociationDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/association/detail-form/association-details-amenity-responsibilities-exterior-numeric.tsx